import React, {useEffect, useState} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import {customerApi} from '../../api/Api';
import {isLogin} from '../../utils';
import {TOKEN_KEY} from '../../utils/session';
import ProfileCompletionModal from './ProfileCompletionModal';

export const PROFILE_REMINDER_PREFIX = 'natureway_profile_reminder:';

function localDay() {
    const now = new Date(Date.now());
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
}

function wasShownToday(uuid, day) {
    try {
        return !!uuid && localStorage.getItem(`${PROFILE_REMINDER_PREFIX}${uuid}`) === day;
    } catch {
        return false;
    }
}

function rememberShown(uuid, day) {
    try {
        if (uuid) localStorage.setItem(`${PROFILE_REMINDER_PREFIX}${uuid}`, day);
    } catch {
        // The current visit still suppresses repeat prompts when storage is unavailable.
    }
}

export default function ProfileCompletionNotice() {
    const {pathname, key} = useLocation();
    const history = useHistory();
    const token = isLogin() ? localStorage.getItem(TOKEN_KEY) : null;
    const day = localDay();
    const isCheckout = pathname === '/checkout';
    const scope = `${token}:${day}:${isCheckout ? `checkout:${key}` : 'daily'}`;
    const [result, setResult] = useState(null);
    const [handledScope, setHandledScope] = useState(null);

    useEffect(() => {
        let active = true;
        setResult(null);
        if (token && pathname !== '/signin' && handledScope !== scope) {
            customerApi.getProfile().then(response => {
                if (!active || localStorage.getItem(TOKEN_KEY) !== token) return;
                const profile = response.data?.data;
                if (profile?.customer && profile.profile_completion?.is_complete === false
                    && (isCheckout || !wasShownToday(profile.customer.uuid, day))) {
                    rememberShown(profile.customer.uuid, day);
                    setResult({scope, profile});
                } else {
                    setHandledScope(scope);
                }
            }).catch(() => {
                // Profile setup must not interrupt shopping when the API is unavailable.
            });
        }
        return () => {active = false;};
    }, [token, pathname, scope, handledScope, day, isCheckout]);

    if (!token || handledScope === scope || result?.scope !== scope) return null;
    return <ProfileCompletionModal key={scope} profile={result.profile} token={token}
        onLater={() => setHandledScope(scope)}
        onSaved={() => {
            setHandledScope(scope);
            if (!isCheckout) history.replace('/account', {profileSetupSaved:true});
        }} />;
}
